import { HttpBackend, HttpClient } from '@angular/common/http';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateService,
  TranslationObject,
} from '@ngx-translate/core';
import { catchError, of } from 'rxjs';
import { NGSW_BYPASS_PARAM, NGSW_BYPASS_VALUE } from '../../api/http.const';

const I18N_PATH_PREFIX = './assets/i18n/';
const I18N_PATH_SUFFIX = '.json';

@Injectable()
export class SelfHealingMissingTranslationHandler implements MissingTranslationHandler {
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly destroyRef = inject(DestroyRef);
  private readonly attempted = new Set<string>();

  handle(params: MissingTranslationHandlerParams): string {
    const translate = params.translateService;
    const lang = translate.getCurrentLang() ?? translate.getFallbackLang();

    if (lang && !this.attempted.has(lang)) {
      this.attempted.add(lang);
      this.refetch(lang, translate);
    }

    return params.key;
  }

  private refetch(lang: string, translate: TranslateService): void {
    // ngsw-bypass forces the fetch past the service worker to the network, so a
    // client pinned to a stale cached dictionary gets the current file.
    this.http
      .get<TranslationObject>(`${I18N_PATH_PREFIX}${lang}${I18N_PATH_SUFFIX}`, {
        params: { [NGSW_BYPASS_PARAM]: NGSW_BYPASS_VALUE },
      })
      .pipe(
        catchError(() => of(null)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((fresh) => {
        if (fresh) {
          translate.setTranslation(lang, fresh, true);
        }
      });
  }
}
